const LENDER = require('../constants/lenders');

const AUTOMONEY_TIERS = {
    T1 : 504,
    T2 : 505,
    T3 : 506,
    T4 : 507,
    T5 : 508,
    TY : 509
}

const MOTONOVO_TIERS = {
    A1: 397,
    A2: 398,
    A3: 399,
    A4: 400,
    C: 416
}

/**
 * Eric note:
 * 
 * This is an attempt at making LTVs more manageable. These will eventually sit on the 
 * proposal itself, but for now they are here.
 * 
 * Quotes API should construct the ltv object on the proposal.
 * 
 * LTV is either simple or complex. All have a baseline comparison value (cap clean, glasses retail, etc)
 * 
 * A simple LTV is just a % of the baseline.
 * 
 * A complex LTV is built in a way that allows for different percentile values and baselines, differing for
 * a) Finance Type (HP, PCP)
 * b) Vehicle Condition (New, Used)
 * c) Vehicle Type (Car, Van, Bike)
 * 
 * When moving to the quotes API, it should return the appropriate LTV object for the proposal tier id, this
 * will simplify the logic in the getMaxLtv function which uses this object.
 */
const LTVS = [
    {
        financeCompanyId: LENDER.ADVANTAGE,
        tiers: [
            { tierId: 572, simple: 1.15, baseline: 0 },//A1
            { tierId: 573, simple: 1.15, baseline: 0 },//A2
            { tierId: 574, simple: 1.15, baseline: 0 },//A3
            { tierId: 575, simple: 1.15, baseline: 0 },//A4
            { tierId: 576, simple: 1.15, baseline: 0 },//B1
            { tierId: 577, simple: 1.15, baseline: 0 },//B2
            { tierId: 578, simple: 1.15, baseline: 0 },//B3
            { tierId: 579, simple: 1.10, baseline: 0 },//C1
            { tierId: 580, simple: 1.10, baseline: 0 },//C2
            { tierId: 581, simple: 1.10, baseline: 0 },//C3
            { tierId: 582, simple: 1.10, baseline: 0 },//D1
            { tierId: 583, simple: 1.10, baseline: 0 } //E1
        ],
        simple: 1.15,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.AUTOMONEY,
        tiers: [
            { tierId: AUTOMONEY_TIERS.T1, simple: 1.00, baseline: 0 },
            { tierId: AUTOMONEY_TIERS.T2, simple: 0.95, baseline: 0 },
            { tierId: AUTOMONEY_TIERS.T3, simple: 0.95, baseline: 0 },
            { tierId: AUTOMONEY_TIERS.T4, simple: 1.00, baseline: 0 },
            { tierId: AUTOMONEY_TIERS.T5, simple: 1.00, baseline: 0 },
            { tierId: AUTOMONEY_TIERS.TY, simple: 0.90, baseline: 0 },
        ],
        simple: 1.00,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.BILLING,
        simple: 1.00,
        baseline: 3
    },
    {
        financeCompanyId: LENDER.MONEYBARN,
        simple: 1.3,
        tiers:[
            { 
                tierId: 116, //Tier1A
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.1,
                                    baseline: 0
                                }
                            ],
                            1:[
                                { //van
                                    limit: 0,
                                    simple: 1.1,
                                    baseline: 0,
                                    vatQualifying: true
                                },
                                { //van
                                    limit: 0,
                                    simple: 1.3,
                                    baseline: 0, 
                                    vatQualifying: false
                                }
                            ]
                        }
                    }
                } , 
            },
            { 
                tierId: 117, //Tier1B
                complex: {
                    0:{// hp
                        0:{ // used
                            0:[
                                { //car
                                    limit: 0,
                                    simple: 1.1,
                                    baseline: 0
                                }
                            ],
                            1:[
                                { //van
                                    limit: 0,
                                    simple: 1.1,
                                    baseline: 0,
                                    vatQualifying: true
                                },
                                { //van
                                    limit: 0,
                                    simple: 1.3,
                                    baseline: 0, 
                                    vatQualifying: false
                                }
                            ]
                        }
                    }
                }, 
            },
            { 
                tierId: 118, //Tier1C
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.1,
                                    baseline: 0
                                }
                            ],
                            1:[
                                { //van
                                    limit: 0,
                                    simple: 1.1,
                                    baseline: 0,
                                    vatQualifying: true
                                },
                                { //van
                                    limit: 0,
                                    simple: 1.3,
                                    baseline: 0, 
                                    vatQualifying: false
                                }
                            ]
                        }
                    }
                }, 
            },
            { 
                tierId: 103, // Tier 2A
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 0
                                }
                            ],
                            1: [
                                { //van
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 0,
                                    vatQualifying: true
                                },
                                { //van
                                    limit: 0,
                                    simple: 1.2,
                                    baseline: 0, 
                                    vatQualifying: false
                                }
                            ]
                        }
                    }
                },
            },
            { 
                tierId: 104,// Tier 2B
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 0
                                }
                            ],
                            1: [
                                { //van
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 0,
                                    vatQualifying: true
                                },
                                { //van
                                    limit: 0,
                                    simple: 1.2,
                                    baseline: 0, 
                                    vatQualifying: false
                                }
                            ]
                        }
                    }
                },
            },
            { 
                tierId: 105, // Tier 2C
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 0
                                }
                            ],
                            1: [
                                { //van
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 0,
                                    vatQualifying: true
                                },
                                { //van
                                    limit: 0,
                                    simple: 1.2,
                                    baseline: 0, 
                                    vatQualifying: false
                                }
                            ]
                        }
                    }
                },
            },
            { 
                tierId: 67, //Tier3A
                complex:{ 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 0
                                }
                            ],
                            1: [
                                { //van
                                    limit: 0,
                                    simple: 1.0,
                                    baseline: 2,
                                    vatQualifying: true
                                },
                                { //van
                                    limit: 0,
                                    simple: 1.2,
                                    baseline: 2, 
                                    vatQualifying: false
                                }
                            ]
                        }
                    }
                }
            }
        ],
        baseline: 0
    },
    {
        financeCompanyId: LENDER.MONEYWAY,
        tiers: [
            { tierId: 167, simple: 1.20, baseline: 0 },
            { tierId: 168, simple: 1.20, baseline: 0 },
            { tierId: 169, simple: 1.20, baseline: 0 },
            { tierId: 170, simple: 1.00, baseline: 0 },
            { tierId: 171, simple: 1.00, baseline: 0 },
            { tierId: 172, simple: 1.00, baseline: 0 },
            { tierId: 173, simple: 1.00, baseline: 0 },
            { tierId: 174, simple: 1.00, baseline: 0 },
        ],
        simple: 1.20,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.OODLE,
        simple: 1.25,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.TANDEM,
        tiers: [
            { tierId: 516, simple: 1.20, baseline: 0 },
            { tierId: 517, simple: 1.20, baseline: 0 },
            { tierId: 518, simple: 1.20, baseline: 0 },
            { tierId: 519, simple: 1.20, baseline: 0 },
            { tierId: 520, simple: 1.20, baseline: 0 },
            { tierId: 521, simple: 1.20, baseline: 0 },
            { tierId: 522, simple: 1.20, baseline: 0 },
            { tierId: 523, simple: 1.20, baseline: 0 },
            { tierId: 524, simple: 1.20, baseline: 0 },
            { tierId: 525, simple: 1.10, baseline: 0 },
            { tierId: 526, simple: 1.10, baseline: 0 },
            { tierId: 527, simple: 1.10, baseline: 0 },
            { tierId: 528, simple: 1.10, baseline: 0 },
            { tierId: 529, simple: 1.10, baseline: 0 },
            { tierId: 530, simple: 1.10, baseline: 0 },
        ],
        simple: 1.20,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.ALPHERA,
        complex:{
            0:{// hp
                0:{ // used
                    0:[//car
                        { 
                            limit: 0,
                            simple: 1.35,
                            baseline: 4
                        },
                    ],
                    1:[ //van
                        { 
                            limit: 0,
                            simple: 1.15,
                            baseline: 4, 
                        }
                    ]
                }
            }
        },
        simple: 1.35,
        baseline: 4
    },
    {
        financeCompanyId: LENDER.BNP,
        simple: 0.97,
        baseline: 3
    },
    {
        financeCompanyId: LENDER.CLOSE,
        simple: 1.20,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.CREDITAGRICOLE,
        complex:{
            0:{// hp
                0:{ // used
                    0:[//car
                        { 
                            limit: 0,
                            simple: 1.5,
                            baseline: 3
                        },
                        { 
                            limit: 35000,
                            simple: 1.25,
                            baseline: 3
                        },
                    ],
                    1:[ //van
                        { 
                            limit: 0,
                            simple: 1.10,
                            baseline: 3, 
                        }
                    ]
                }
            }
        },
        simple: 1.5,
        baseline: 3
    },
    {
        financeCompanyId: LENDER.MOTONOVO,
        simple: 1.05,
        tiers:[
            { 
                tierId: MOTONOVO_TIERS.A1, //Tier1A
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.0,
                                    buffer: 1000,
                                    baseline: 3
                                }
                            ],
                        }
                    },
                    1:{// pcp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.1,
                                    buffer: 250,
                                    baseline: 3
                                }
                            ],
                        }
                    }
                } , 
            },
            { 
                tierId: MOTONOVO_TIERS.A2, //Tier1A
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.0,
                                    buffer: 1000,
                                    baseline: 3
                                }
                            ],
                        }
                    },
                    1:{// pcp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.1,
                                    buffer: 250,
                                    baseline: 3
                                }
                            ],
                        }
                    }
                } , 
            },
            { 
                tierId: MOTONOVO_TIERS.A3, //Tier1A
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.0,
                                    buffer: 1000,
                                    baseline: 3
                                }
                            ],
                        }
                    },
                    1:{// pcp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.1,
                                    buffer: 250,
                                    baseline: 3
                                }
                            ],
                        }
                    }
                } , 
            },
            { 
                tierId: MOTONOVO_TIERS.A4, //Tiera4
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.05,
                                    buffer: 0,
                                    baseline: 3
                                }
                            ],
                        }
                    },
                    1:{// pcp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.05,
                                    buffer: 0,
                                    baseline: 3
                                }
                            ],
                        }
                    }
                } , 
            },
            { 
                tierId: MOTONOVO_TIERS.C, //Tier C
                complex: { 
                    0:{// hp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.02,
                                    buffer: 0,
                                    baseline: 3
                                }
                            ],
                        }
                    },
                    1:{// pcp
                        0:{ // used
                            0: [
                                { //car
                                    limit: 0,
                                    simple: 1.02,
                                    buffer: 0,
                                    baseline: 3
                                }
                            ],
                        }
                    }
                } , 
            },
        ],
        baseline: 3
    },
    {
        financeCompanyId: LENDER.NORTHRIDGEFINANCE,
        complex:{
            0:{// hp
                0:{ // used
                    0:[//car
                        { 
                            limit: 0,
                            simple: 1.35,
                            baseline: 4
                        },
                        { 
                            limit: 20000,
                            simple: 1.25,
                            baseline: 4
                        },
                    ],
                }
            }
        },
        simple: 1.25,
        baseline: 4
    },
    {
        financeCompanyId: LENDER.ZOPA,
        simple: 1.25,
        complex:{
            0:{// hp
                0:{ // used
                    0:[//car
                        { 
                            limit: 0,
                            simple: 1.25,
                            baseline: 3
                        },
                        { 
                            limit: 25000,
                            simple: 1.25,
                            baseline: 3
                        },
                    ],
                }
            }
        },
        tiers: [
            { 
                tierId: 542, // 3c1
                simple: 1.25,
                baseline: 3 
            },
            { 
                tierId: 543, //3d
                simple: 1.25,
                baseline: 3 
            },
            { 
                tierId: 544, //3e
                simple: 1.25,
                baseline: 3  
            },
        ],
        baseline: 3
    },
    {
        financeCompanyId: LENDER.V12,
        simple: 1.20,
        baseline: 3
    },
    {
        financeCompanyId: LENDER.RATESETTER,
        simple: 1.9,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.MANNISLAND,
        simple: 1.20,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.METROBANK,
        simple: 1.20,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.SMF,
        simple: 1.10,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.MARSH,
        simple: 1.20,
        baseline: 0
    },
    {
        financeCompanyId: LENDER.M247,
        simple: 1.00,
        baseline: 0
    },
]

module.exports = { 
    LTVS
}